export default "__VITE_ASSET__ChBP3J2k__"